import { Controller } from "@hotwired/stimulus"

// Instagram の共同投稿者(コラボ投稿)の username をタグ入力する。
// 値は instagram_scheduled_post[collaborators][] の hidden で送る(全削除でも空配列が届くよう、ビュー側に value="" の hidden を別に置く)
const USERNAME_FORMAT = /^[a-z0-9._]{1,30}$/

export function normalizeUsername(raw) {
  return String(raw ?? "").trim().replace(/^@/, "").toLowerCase()
}

export function collaboratorError(name, list, { max, self }) {
  // 上限に達しているときは入力内容に関係なく上限を伝える
  if (list.length >= max) return `共同投稿者は${max}人まで指定できます`
  if (!name) return "ユーザーネームを入力してください"
  if (!USERNAME_FORMAT.test(name)) return "英数字・ピリオド・アンダースコアの30文字以内で入力してください"
  if (list.includes(name)) return "すでに追加されています"
  if (self && name === self.toLowerCase()) return "投稿するアカウント自身は指定できません"
  return null
}

export default class extends Controller {
  static targets = ["input", "list", "error", "addButton"]
  static values = { usernames: Array, max: { type: Number, default: 3 }, self: String, fieldName: String }

  connect() {
    this.usernames = [...this.usernamesValue]
    this.render()
  }

  keydown(event) {
    // IME の変換確定の Enter では追加しない(Safari は isComposing が false のまま keyCode 229 を送る)
    if (event.isComposing || event.keyCode === 229) return
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()
      this.add()
    }
  }

  add() {
    const name = normalizeUsername(this.inputTarget.value)
    const error = collaboratorError(name, this.usernames, { max: this.maxValue, self: this.selfValue })
    if (error) {
      this.showError(error)
      return
    }
    this.usernames.push(name)
    this.inputTarget.value = ""
    this.showError(null)
    this.render()
  }

  remove(event) {
    const name = event.currentTarget.dataset.username
    this.usernames = this.usernames.filter((u) => u !== name)
    this.showError(null)
    this.render()
  }

  showError(message) {
    this.errorTarget.textContent = message || ""
    this.errorTarget.classList.toggle("hidden", !message)
  }

  render() {
    this.listTarget.replaceChildren(...this.usernames.map((name) => this.chip(name)))
    this.inputTarget.disabled = this.usernames.length >= this.maxValue
    if (this.hasAddButtonTarget) this.addButtonTarget.disabled = this.inputTarget.disabled
    this.inputTarget.placeholder = this.inputTarget.disabled ? `最大${this.maxValue}人まで追加済み` : "ユーザーネームを入力して Enter"
  }

  chip(name) {
    const wrapper = document.createElement("span")
    wrapper.className = "badge badge-outline gap-1 py-3"

    const label = document.createElement("span")
    label.textContent = `@${name}`

    const button = document.createElement("button")
    button.type = "button"
    // モバイルはタップしやすいサイズにする
    button.className = "btn btn-ghost btn-sm sm:btn-xs btn-circle"
    button.dataset.username = name
    button.dataset.action = "click->ig-collaborators#remove"
    button.setAttribute("aria-label", `@${name} を削除`)
    button.textContent = "×"

    const hidden = document.createElement("input")
    hidden.type = "hidden"
    hidden.name = this.fieldNameValue
    hidden.value = name

    wrapper.append(label, button, hidden)
    return wrapper
  }
}
